import script from "./grid-layout2.vue?vue&type=script&setup=true&lang=js"
export * from "./grid-layout2.vue?vue&type=script&setup=true&lang=js"

import "./grid-layout2.vue?vue&type=style&index=0&id=4c05af64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c05af64"]])

export default __exports__